import BaseService from "../BaseService";
import _ from "lodash";

class CartService extends BaseService {
    create = async () => {
        var data = await this._api.post("store/cart/create");
        return data;
    };

    get = async (id) => {
        var data = await this._api.get(`/store/cart/get`, { params: { id } });
        return data;
    };

    getCurrent = async (id) => {
        var data = await this._api.get(`/store/cart/get_current`);
        return data;
    };

    updateLineItem = async ({ id, line }) => {
        var data = await this._api.post(`/store/cart/update_line_item`, { id, line });
        return data;
    }


    addLineItem = async ({ id, line }) => {
        var data = await this._api.post(`/store/cart/add_line_item`, { id, line });
        return data;
    }

    addMultiLineItem = async ({ id, line_items }) => {
        var data = await this._api.post(`/store/cart/add_multi_line_item`, { id, line_items });
        return data;
    }

    updateShippingAddress = async ({ id, shipping_address }) => {
        var data = await this._api.post(`/store/cart/update_shipping_address`, { id, shipping_address });
        return data;
    }


    createInvoiceFile = async ({ id }) => {
        var data = await this._api.post(`/store/cart/create_invoice_file`, { id });
        return data;
    }

    complete = async ({ id }) => {
        var ref_code = localStorage.getItem("ref_code");
        var ref_time = localStorage.getItem("ref_time");
        var data = await this._api.post(`/store/cart/complete`, { id, ref_code, ref_time });
        return data;
    }

    validateInventory = async ({ id }) => {
        var data = await this._api.post(`/store/cart/validate_inventory`, { id });
        return data;
    }

    setCustomer = async ({ id }) => {
        var data = await this._api.post(`/store/cart/set_customer`, { id });
        return data;
    }

    setVoucher = async ({ id, voucher_code }) => {
        var data = await this._api.post(`/store/cart/set_voucher`, { id, voucher_code });
        return data;
    }

    removeVoucher = async ({ id }) => {
        var data = await this._api.post(`/store/cart/remove_voucher`, { id });
        return data;
    }


    setPoint = async ({ id, point }) => {
        var data = await this._api.post(`/store/cart/set_point`, { id, point });
        return data;
    }

    removePoint = async ({ id }) => {
        var data = await this._api.post(`/store/cart/remove_point`, { id });
        return data;
    }



    reby = async ({ id, order_id }) => {
        var data = await this._api.post(`/store/cart/reby`, { id, order_id });
        return data;
    }






}
export default CartService;
